import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Lightbulb, Users } from 'lucide-react';
import './MobileLandingPage.css';
import { useDesign } from './App';

const MobileLandingPage = () => {
  const navigate = useNavigate();
  const { designConfig } = useDesign();

  const handleArchiveClick = () => {
    // Check if user is logged in
    const sessionToken = localStorage.getItem('user_session_token');
    
    if (sessionToken) {
      // User is logged in - navigate to archive
      navigate('/archive');
    } else {
      // User is not logged in - redirect to login with return path
      navigate('/login?redirect=/archive');
    }
  };

  return (
    <div 
      className="mobile-landing-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}${designConfig.landing_mobile})`
      }}
    >
      <div className="mobile-landing-content">
        {/* Logo Section */}
        <div className="mobile-landing-logo-section">
          <img 
            src="/debatify-typo-landingpage4.svg" 
            alt="Debatefy - Where minds meet to grow" 
            className="mobile-landing-logo"
          />
        </div>
        
        {/* Start Debate Button */}
        <button 
          className="mobile-landing-cta-button"
          onClick={() => navigate('/choose-mode')}
        >
          START DEBATE
        </button>
        
        {/* Feature Cards */}
        <div className="mobile-landing-features-grid">
          <div 
            className="mobile-landing-feature-card"
            onClick={() => navigate('/factchecking')}
          >
            <div className="mobile-landing-feature-icon-wrapper">
              <CheckCircle className="mobile-landing-feature-icon" />
            </div>
            <h3>Fact-Checking</h3>
            <p>Real-time verification through Perplexity AI ensures every argument is grounded in truth</p>
          </div>
          
          <div 
            className="mobile-landing-feature-card"
            onClick={() => navigate('/insight-scoring')}
          >
            <div className="mobile-landing-feature-icon-wrapper">
              <Lightbulb className="mobile-landing-feature-icon" />
            </div>
            <h3>Insight Scoring</h3>
            <p>Rewards depth of thought and new perspectives, not rhetorical victories</p>
          </div>
          
          <div 
            className="mobile-landing-feature-card"
            onClick={() => navigate('/collaborative-growth')}
          >
            <div className="mobile-landing-feature-icon-wrapper">
              <Users className="mobile-landing-feature-icon" />
            </div>
            <h3>Collaborative Growth</h3>
            <p>Split-timer system gives space for thinking without time pressure</p>
          </div>
        </div>
        
        {/* Secondary Actions */}
        <div className="mobile-landing-secondary-actions">
          <button 
            className="mobile-landing-secondary-btn"
            onClick={handleArchiveClick}
          >
            archive
          </button>
          <button 
            className="mobile-landing-secondary-btn"
            onClick={() => navigate('/pricing')}
          >
            pricing
          </button>
          <button 
            className="mobile-landing-secondary-btn"
            onClick={() => navigate('/admin')}
          >
            admin
          </button>
          <button 
            className="mobile-landing-secondary-btn"
            onClick={() => navigate('/about')}
          >
            about
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileLandingPage;
